import { Component, h } from "@lukekaalim/act"
import { PropsForTypeOfLogicEditor } from "./common"
import { html } from "@lukekaalim/act-web"

export const VisibilitySourceEditor: Component<PropsForTypeOfLogicEditor<"visibility-source">> = ({ logic, onLogicDataChange }) => {
  return [
    h(html.label, {}, [
      h(html.span, {}, 'Strength'),
      h(html.input, { type: 'number', valueAsNumber: logic.data.strength, onInput(event) {
        onLogicDataChange({ strength: this.valueAsNumber })
      }, })
    ])
  ]
}

export const DoorEditor: Component<PropsForTypeOfLogicEditor<"door">> = ({ logic, onLogicDataChange }) => {
  return [
    h(html.label, {}, [
      h(html.span, {}, 'Open'),
      h(html.input, { type: 'checkbox', checked: logic.data.open, onInput(event) {
        onLogicDataChange({ open: this.checked })
      }, })
    ])
  ]
}